export const environment = {
    production: true,
    apiUrl: '/webapi/api',
    company:'街口',
    domain: 'https://www.jkoam.com',
};
